package org.zq.astrock_ai.ui.research.gushi.components

import androidx.compose.foundation.Canvas
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Path
import androidx.compose.ui.graphics.drawscope.Stroke
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import org.zq.astrock_ai.ui.research.gushi.StockColors

@Composable
fun EquityCurveMini(
    values: List<Double>,
    up: Boolean,
    modifier: Modifier = Modifier,
) {
    val color = if (up) StockColors.UpRed else StockColors.DownGreen
    Column(modifier = modifier) {
        Text("权益曲线", color = StockColors.TextSecondary, fontSize = 10.sp)
        Spacer(Modifier.height(2.dp))
        Canvas(modifier = Modifier.fillMaxWidth().height(36.dp)) {
            if (values.size < 2) return@Canvas
            val minV = values.minOrNull() ?: return@Canvas
            val maxV = values.maxOrNull() ?: return@Canvas
            val range = (maxV - minV).coerceAtLeast(0.0001)
            val path = Path()
            values.forEachIndexed { index, value ->
                val x = size.width * index / (values.lastIndex.coerceAtLeast(1))
                val y = size.height * (1f - ((value - minV) / range).toFloat())
                if (index == 0) path.moveTo(x, y) else path.lineTo(x, y)
            }
            drawPath(path, color = color, style = Stroke(width = 2f))
        }
    }
}
